import { convertWeblabMetaElementOnceWhenDomReady } from '../../utils/weblab-helpers';
import { createMetricsPublisher } from '../../metrics/metrics-publisher';
import { fireReadyEvent } from './events';
export const register = tagName => descriptor => ({
  ...descriptor,
  finisher(clazz) {
    registerImpl(tagName, clazz);
  }
});
export function registerImpl(tagName, clazz) {
  if (!window.customElements.get(tagName)) {
    try {
      convertWeblabMetaElementOnceWhenDomReady();
      window.customElements.define(tagName, clazz);
      fireReadyEvent(tagName, 'katal-component-ready');
    } catch (e) {
      const {
        publisher
      } = createMetricsPublisher();
      publisher.publishCounterMonitor(`KatalInternalMetrics:registration-error:any`, 1);
      publisher.publishCounterMonitor(`KatalInternalMetrics:registration-error:${tagName}`, 1);
      console.error(`Unable to register ${tagName}`, e);
    }
  }
}
//# sourceMappingURL=register.js.map